/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

export default async function generateCSV(data, columnsToInclude) {
  const columnNames = _.map(columnsToInclude, (column) => {
    const columnLabel = column.label.replace(/"/g, '""')
    return `"${columnLabel}"`;
  });

  // Only include data from columns in columnsToInclude
  const rows = _.map(data, (row) => {
    return _.map(columnsToInclude, (column) => {
      return row[column.name];
    });
  });

  // Encode data
  const encodedRows = _.map(rows, (row) => {
    return _.map(row, (value) => {
      //sanitize string in preparation for CSV and XPath
      if (value) {
        const sanitizedRowString = value.replace(/[&<>'"]/g, (char) => {
          switch (char) {
            case '&':
              return '&amp;';
            case '<':
              return '&lt;';
            case '>':
              return '&gt;';
            case '"':
              return '&quot;';
            case "'":
              return '&apos;';
            default:
              return '';
          }
        });

        return `"${sanitizedRowString}"`;
      } else {
        return '';
      }
    });
  }).join('\n');

  const csvContent = `${columnNames},\n${encodedRows}`;

  const timeout = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };
  await timeout(300);

  return csvContent;
}
